import React, { FC, useCallback } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';

type Props = {
    to: string;
    checkIsActive?: (location: any, to: string) => boolean;
    children: React.ReactElement;
    onClick?: (e: React.MouseEvent) => void;
};

const LinkContainer: FC<Props> = ({ to, checkIsActive, children, onClick, ...props }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isActive = checkIsActive?.(location, to) ?? useMatch(to);

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            onClick?.(e) ?? navigate(to);
        },
        [navigate, onClick, to]
    );

    return React.cloneElement(children, {
        ...props,
        href: to,
        onClick: handleClick,
        className: `${children.props.className || ''} ${isActive ? 'active' : ''}`.trim(),
    });
};

export default LinkContainer;
